/**
 * AQ-Cloud2 public footer.
 *
 * Per design-system/MASTER.md §12, authenticated pages do NOT show a footer
 * — the status bar takes that role. The real footer only appears on public
 * pages (login, register, auth callback, unauthorized) and print/PDF.
 */
import React from 'react'
import { Link } from 'react-router-dom'
import { BrandLockup } from '@/components/layout/BrandLockup'

interface FooterProps {
  /** Optional build/version string surfaced in the footer (e.g. "v0.10.0 · dev"). */
  version?: string
  className?: string
}

const YEAR = new Date().getFullYear()

export const Footer = ({ version, className }: FooterProps): JSX.Element => {
  return (
    <footer className={`bg-card border-t border-border ${className ?? ''}`}>
      <div className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between text-xs text-muted-foreground flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <BrandLockup size="sm" compact to={null} />
          <span>© {YEAR} Revalize, Inc. All rights reserved.</span>
        </div>
        <nav className="flex items-center gap-5" aria-label="Footer">
          <Link to="/legal/terms" className="hover:text-foreground transition-colors duration-fast">
            Terms
          </Link>
          <Link to="/legal/privacy" className="hover:text-foreground transition-colors duration-fast">
            Privacy
          </Link>
          <a
            href="https://support.revalizesoftware.com/"
            target="_blank"
            rel="noreferrer noopener"
            className="hover:text-foreground transition-colors duration-fast"
          >
            Support
          </a>
          <a
            href="https://status.revalize.com"
            target="_blank"
            rel="noreferrer noopener"
            className="hover:text-foreground transition-colors duration-fast"
          >
            Status
          </a>
          {version ? <span className="num text-muted-foreground/70">{version}</span> : null}
        </nav>
      </div>
    </footer>
  )
}
